import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconDocumentSvg } from "./IconDocumentSvg.mjs";
const IconDocument = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconDocumentSvg, ...iconProps });
};
export {
  IconDocument
};
